module.exports = __webpack_public_path__ + "static/media/myrso.f6c61f07.png";